import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Spinner = () => {
  return (
    <div className="flex justify-center items-center my-1">
      <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize: 24,
              color: "$theme",
            }}
            spin
          />
        }
      />
    </div>
  );
};

export default Spinner;
